<template>
  <FreeBottomSheet :name="name">
    <div class="space-y-6 p-4">
      <h2 class="text-text-neutral-primary text-xl font-semibold">Navigate</h2>

      <div class="space-y-4">
        <div class="space-y-3">
          <div class="flex space-x-2">
            <input
              v-model="customUrl"
              type="text"
              placeholder="Введите URL"
              class="bg-background-neutral-primary text-text-neutral-primary flex-grow rounded border px-3 py-2"
            />
            <button
              class="bg-background-positive-primary text-static-white hover:bg-background-info-accent rounded px-4 py-2 transition-colors"
              type="button"
              @click="navigateToUrl"
            >
              Navigate
            </button>
          </div>

          <div class="text-text-neutral-secondary">
            <p>
              Используется нативный метод navigate() для навигации внутри супер
              аппа
            </p>
          </div>
        </div>
      </div>
    </div>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import { FreeBottomSheet, freedomApp } from 'freedom-shared';

  interface Props {
    name: string;
  }

  defineProps<Props>();

  const customUrl = ref('https://ticketon.kz/miniapp/event-detail/59765');

  const navigateToUrl = () => {
    const url = customUrl.value.trim();

    if (!url) {
      alert('Пожалуйста, введите URL');
      return;
    }

    // Use native navigate method
    freedomApp.lib.navigate(url);
  };
</script>
